export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-[#0A1128] via-[#1a1f3a] to-[#2d1b4e]">
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/30"></div>
      
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#00D9FF]/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#8B5CF6]/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-block">
              <span className="text-[#00D9FF] text-sm font-semibold tracking-[0.3em] uppercase">SECURE • PRIVATE • UNLIMITED</span>
            </div>
            
            <h1 className="text-white">
              <div className="text-5xl md:text-7xl font-light mb-2">Your Digital</div>
              <div className="text-5xl md:text-7xl font-extrabold bg-gradient-to-r from-white to-[#00D9FF] bg-clip-text text-transparent">Privacy Shield</div>
            </h1>
            
            <p className="text-gray-300 text-lg md:text-xl font-light leading-relaxed max-w-xl">
              Enterprise-grade VPN protection for individuals who value their online freedom and digital privacy
            </p>
            
            <div className="flex flex-wrap gap-4">
              <button onClick={() => scrollToSection('contact')} className="bg-gradient-to-r from-[#00D9FF] to-[#00a8cc] text-white px-8 py-4 rounded-full font-semibold text-lg hover:shadow-2xl hover:shadow-[#00D9FF]/50 transition-all duration-300 hover:scale-105 whitespace-nowrap">
                Download Now
              </button>
              <button onClick={() => scrollToSection('features')} className="text-white px-8 py-4 rounded-full font-semibold text-lg border-2 border-white/30 hover:border-[#00D9FF] hover:bg-[#00D9FF]/10 transition-all duration-300 flex items-center gap-2 whitespace-nowrap">
                Learn More
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>

          <div className="relative hidden md:block">
            <div className="relative w-full h-[500px]">
              {/* Network visualization */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative w-80 h-80">
                  {/* Center shield */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-32 h-32 bg-gradient-to-br from-[#00D9FF] to-[#8B5CF6] rounded-2xl flex items-center justify-center shadow-2xl shadow-[#00D9FF]/50 animate-pulse">
                    <i className="ri-shield-check-line text-6xl text-white"></i>
                  </div>
                  
                  {/* Orbiting cards */}
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#162032] p-4 rounded-xl shadow-xl border border-[#00D9FF]/30 animate-float">
                    <div className="text-[#00D9FF] text-sm font-semibold whitespace-nowrap">256-bit Encryption</div>
                  </div>
                  
                  <div className="absolute bottom-0 left-0 bg-[#162032] p-4 rounded-xl shadow-xl border border-[#00D9FF]/30 animate-float" style={{ animationDelay: '0.5s' }}>
                    <div className="text-[#00D9FF] text-sm font-semibold whitespace-nowrap">Zero Logs</div>
                  </div>
                  
                  <div className="absolute bottom-0 right-0 bg-[#162032] p-4 rounded-xl shadow-xl border border-[#00D9FF]/30 animate-float" style={{ animationDelay: '1s' }}>
                    <div className="text-[#00D9FF] text-sm font-semibold whitespace-nowrap">Kill Switch</div>
                  </div>
                  
                  {/* Connection lines */}
                  <div className="absolute inset-0">
                    <div className="absolute top-1/4 left-1/2 w-0.5 h-20 bg-gradient-to-b from-[#00D9FF] to-transparent"></div>
                    <div className="absolute bottom-1/4 left-1/4 w-20 h-0.5 bg-gradient-to-r from-[#00D9FF] to-transparent rotate-45"></div>
                    <div className="absolute bottom-1/4 right-1/4 w-20 h-0.5 bg-gradient-to-l from-[#00D9FF] to-transparent -rotate-45"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
}
